import { SHIPPING_CONDITION_CODE } from '../../../../shared/constants/shipping-conditions-codes';
import { delivery } from './delivery/';
import { pickUp } from './pick-up';
import { ownfreight } from './ownfreight';

export const bulkCement = {
  [SHIPPING_CONDITION_CODE.DELIVERY]: delivery,
  [SHIPPING_CONDITION_CODE.PICK_UP]: pickUp,
  [SHIPPING_CONDITION_CODE.OWN_FREIGHT]: ownfreight,
};
